// extracted by mini-css-extract-plugin
module.exports = {"mobile":"360","tablet":"768","desktop":"1280","footerSocial":"_3YCdE","footerSocialTitle":"_3bpPi","footerSocialWrapper":"_3kz_C"};